<ng-template #classic let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="d-flex justify-content-end">
            <span data-dismiss="modal" (click)="cancelEdit()">
                <i class="material-icons">close</i>
            </span>
        </div>
        <div class="text-center mb-4">
            <span class="modal-title">{{ getHeader | uppercase }}</span>
        </div>
        <form role="form" [formGroup]="formEdit" novalidate>
            <div class="form-group">
                <input type="text" class="form-control"
                    placeholder="{{ 'CUSTOMER_ORG_FORM.NAME_FIELD_PLC' | translate }}"
                    [ngClass]="{'is-valid': nameControl.valid, 'is-invalid': nameControl.invalid && nameControl.touched}"
                    formControlName="name">
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': nameControl.invalid && nameControl.touched ? 'block' : 'none'}">
                    <span> {{ 'CUSTOMER_ORG_FORM.NAME_FIELD_ERR' | translate }} </span>
                </div>
            </div>

            <div class="form-group" [ngStyle]="{'display': isCustomer ? 'block' : 'none'}">
                <input type="text" class="form-control"
                    placeholder="{{ 'CUSTOMER_ORG_FORM.ORG_NUM_FIELD_PLC' | translate }}"
                    [ngClass]="{'is-valid': orgControl.valid, 'is-invalid': orgControl.invalid && orgControl.touched}"
                    formControlName="organization">
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': orgControl.invalid && orgControl.touched ? 'block' : 'none'}">
                    <span>{{ 'CUSTOMER_ORG_FORM.ORG_NUM_FIELD_ERR' | translate }} </span>
                </div>
            </div>

            <div class="form-group">
                <input type="text" class="form-control"
                    placeholder="{{ 'CUSTOMER_ORG_FORM.ADDRESS_FIELD_PLC' | translate }}"
                    [ngClass]="{'is-valid': addressControl.valid, 'is-invalid': addressControl.invalid && addressControl.touched}"
                    formControlName="address">
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': addressControl.invalid && addressControl.touched ? 'block' : 'none'}">
                    <span> {{ 'CUSTOMER_ORG_FORM.ADDRESS_FIELD_ERR' | translate }} </span>
                </div>
            </div>

            <div class="form-group">
                <div *ngIf="!showControl" class="d-flex justify-content-center">
                    <app-loader-css></app-loader-css>
                </div>
                <div [ngStyle]="{'display': showControl ? 'block' : 'none'}">
                    <ng-select [dropdownPosition]="'bottom'" [items]="countryList" bindValue="id" [searchable]="true"
                        bindLabel="name" placeholder="{{ 'CUSTOMER_ORG_FORM.COUNTRY_FIELD_PLC' | translate }}"
                        formControlName="country" [multiple]="false" required>
                    </ng-select>
                    <div class="text-center invalid-feedback"
                        [ngStyle]="{'display': countryControl.invalid && countryControl.touched ? 'block' : 'none'}">
                        <span invalid-feedback> {{ 'CUSTOMER_ORG_FORM.COUNTRY_FIELD_ERR' | translate }} </span>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div [ngStyle]="{'display': isCustomer ? 'block' : 'none'}">
                    <ng-select [dropdownPosition]="'bottom'" [items]="marketList" bindValue="market"
                        [searchable]="false" bindLabel="market"
                        placeholder="{{ 'CUSTOMER_ORG_FORM.MARKET_FIELD_PLC' | translate }}" formControlName="market"
                        [multiple]="false" required>
                    </ng-select>
                    <div class="text-center invalid-feedback"
                        [ngStyle]="{'display': marketControl.invalid && marketControl.touched ? 'block' : 'none'}">
                        <span invalid-feedback> {{ 'CUSTOMER_ORG_FORM.MARKET_FIELD_ERR' | translate }} </span>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div [ngStyle]="{'display': isCustomer ? 'none' : 'block'}">
                    <ng-select [dropdownPosition]="'bottom'" [items]="cultureList" bindValue="culture"
                        [searchable]="false" bindLabel="culture"
                        placeholder="{{ 'CUSTOMER_ORG_FORM.ORG_CULTURE_FIELD_PLC' | translate }}"
                        formControlName="culture" [multiple]="false" required>
                    </ng-select>
                    <div class="text-center invalid-feedback"
                        [ngStyle]="{'display': cultureControl.invalid && cultureControl.touched ? 'block' : 'none'}">
                        <span invalid-feedback> {{ 'CUSTOMER_ORG_FORM.ORG_CULTURE_FIELD_ERR' | translate }} </span>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div [ngStyle]="{'display': isCustomer ? 'none' : 'block'}">
                    <ng-select [dropdownPosition]="'bottom'" [items]="timezoneList" bindValue="timezone"
                        [searchable]="false" bindLabel="timezone"
                        placeholder="{{ 'CUSTOMER_ORG_FORM.ORG_TIMEZONE_FIELD_PLC' | translate }}"
                        formControlName="timezone" [multiple]="false" required>
                    </ng-select>
                    <div class="text-center invalid-feedback"
                        [ngStyle]="{'display': timezoneControl.invalid && timezoneControl.touched ? 'block' : 'none'}">
                        <span> {{ 'CUSTOMER_ORG_FORM.ORG_TIMEZONE_FIELD_ERR' | translate }} </span>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div [ngStyle]="{'display': isCustomer ? 'none' : 'block'}">
                    <ng-select [dropdownPosition]="'bottom'" [items]="uploadFormatList" bindValue="uploadFormat"
                        [searchable]="false"
                        placeholder="{{ 'CUSTOMER_ORG_FORM.UPLOAD_FORMAT_PLC' | translate }}"
                        formControlName="uploadFormat" [multiple]="false" required>
                        <ng-template ng-label-tmp let-item="item">
                            {{ 'CUSTOMER_ORG_FORM.UPLOAD_FORMAT_' + (item.uploadFormat | uppercase) | translate }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            {{ 'CUSTOMER_ORG_FORM.UPLOAD_FORMAT_' + (item.uploadFormat | uppercase) | translate }}
                        </ng-template>
                    </ng-select>
                    <div class="text-center invalid-feedback"
                        [ngStyle]="{'display': uploadFormatControl.invalid && uploadFormatControl.touched ? 'block' : 'none'}">
                        <span invalid-feedback> {{ 'CUSTOMER_ORG_FORM.UPLOAD_FORMAT_ERR' | translate }} </span>
                    </div>
                </div>
            </div>

            <div class="form-group" [ngStyle]="{'display': isCustomer ? 'block' : 'none'}">
                <input type="text" class="form-control"
                    placeholder="{{ 'CUSTOMER_ORG_FORM.CONTACT_FIELD_PLC' | translate }}"
                    [ngClass]="{'is-valid': personControl.valid, 'is-invalid': personControl.invalid && personControl.touched}"
                    formControlName="person">
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': personControl.invalid && personControl.touched ? 'block' : 'none'}">
                    <span> {{ 'CUSTOMER_ORG_FORM.CONTACT_FIELD_ERR' | translate }} </span>
                </div>
            </div>
            <!-- Analysis types -->
            <div *ngIf="isCustomer" class="checkbox-title" [ngStyle]="{'display': isCustomer ? 'block' : 'none'}">
                <span> {{ 'CUSTOMER_ORG_FORM.ANALYSIS_TYPES_TITLE' | translate }} </span>
            </div>
            <div *ngIf="isCustomer" class="checkbox-group" [ngStyle]="{'display': isCustomer ? 'block' : 'none'}">
                <div class="form-group checkbox-item" formArrayName="analysisTypes"
                    *ngFor="let order of analysisFormArray.controls; let i = index">
                    <mat-checkbox [formControlName]="i">{{ 'CUSTOMER_ORG_FORM.'+analysisTypes[i].name | translate
                        }}</mat-checkbox>
                </div>
                <div class="text-center invalid-feedback checkbox-alert"
                    [ngStyle]="{'display': analysisTypesControl.invalid && analysisTypesControl.touched ? 'block' : 'none'}">
                    <span> {{ 'CUSTOMER_ORG_FORM.ANALYSIS_ERR' | translate }} </span>
                </div>
            </div>

            <div class="form-group">
                <textarea rows="4" class="form-control"
                    placeholder="{{ 'CUSTOMER_ORG_FORM.NOTE_FIELD_PLC' | translate }}"
                    formControlName="notes"></textarea>
            </div>
        </form>
        <div class="d-flex justify-content-center mt-4">
            <button type="button" class="modal-ok-btn" [disabled]="!enableSaveBtn()" ngbAutofocus (click)="saveData()">
                {{ 'CONSTANTS.BTN_SAVE' | translate | uppercase }} </button>
        </div>
    </div>
</ng-template>